import { ChangeDetectorRef, Component, HostListener, OnInit, TemplateRef, ViewChild, ElementRef, Renderer2  } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MainService } from 'src/app/services/main/main.service';
import { GlobalFilterService } from 'src/app/services/shared/global-filter.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { SimpleDialogComponent } from 'src/app/shared/simple-dialog/simple-dialog.component';
import { LoaderService } from '../../../services/interceptor/loader.service';
import { ContractDialogComponent } from '../../contract/contract-modal/contract-modal.component';
import moment from 'moment';
import { FinancingService } from 'src/app/services/financing/financing.service';
import { getUserProfiles, getStoredLocations } from 'src/app/core/session';

@Component({
  selector: 'app-multioption-form',
  templateUrl: './multioption-form.component.html',
  styleUrls: ['./multioption-form.component.scss']
})
export class MultioptionFormComponent implements OnInit {
  skip_breakdown:any;
  show_process_payment: any = 0;
  can_finance: number = 1;
  show_ar: any = null;
  pp_restricted: any = 0;
  multiCustomerData: any;
  profile = JSON.parse(localStorage.getItem('userProfileData') || '[]') || [];
  subscription: Subscription;
  doctorSettings = JSON.parse(localStorage.getItem('doctorSettings') || '{}');
  subcription_id;
  all_locations = localStorage.getItem('locations') ? getStoredLocations() : [];
  is_allowed: boolean;
  is_allowed_ar: boolean;
  contractData: any;
  dynamicMonth = moment().format('MMMM').toLowerCase();
  cookie = this.mainService.gt_get_cookie('googtrans').split('/').pop();
  daysRemaining: string;
  number_of_record_processed: number = 0;
  locationSubscription: any;
  locationFilter: any;
  show_pp_subscription: any;
  isFinanceStatusLoading: boolean = true;
  show100DollarChallange: any = 0;
  // 0 -> legacy subscription card, 1 -> Subscription v2 card.
  subscription_flow_type: number = 0;

  constructor(public dialog: MatDialog,
    private router: Router,
    public mainService: MainService,
    public _globalFilter: GlobalFilterService,
    public _loaderService: LoaderService,
    public _shared: SharedService,
    private _auth: AuthService,
    public route: ActivatedRoute,
    private renderer: Renderer2,
    private financingService: FinancingService,
    private cdr: ChangeDetectorRef,
  ) {
    this.can_finance = this.profile[0].can_finance;
  }

  @ViewChild('cardRef', { static: false }) cardRef!: ElementRef<any>;
  @ViewChild('bannerRef', { static: false }) bannerRef!: ElementRef<any>;

  business_challenge: any = {};
  intervalId: any;
  countDownBusinessDate;
  @ViewChild('modalTemplate', { static: true }) modalTemplate!: TemplateRef<any>;
  @HostListener('document:click', ['$event'])

  onClick($event) {
    if ($event.target && $event.target.dataset && $event.target.dataset.gtLang) {
      $event.preventDefault();
      this.router.navigateByUrl('/')
        .then(() => this.router.navigate(['/app/finance-customer']));
    }
  }

  ngOnInit() {
    this.show100DollarChallange = this.profile && this.profile[0] && this.profile[0].show_100_dollar_challenge || 0;
    this.refreshSubscriptionFlowType();
    this.resetFinanceFlowState();
    this.checkBusinessLocations();
    let requestedFinanceStatus = false;
    if (this.profile[0].role_id == 4) {
        requestedFinanceStatus = true;
        this.refreshSubscriptionFlowType(this.profile[0].doctor_id);
        this.mainService.getFinanceValues(this.profile[0].doctor_id);
      } else {
        this.locationFilter = this._globalFilter.getFilterObj('location');
        if (this.locationFilter && this.locationFilter.id) {
          requestedFinanceStatus = true;
          this.refreshSubscriptionFlowType(this.locationFilter.id);
          this.mainService.getFinanceValues(this.locationFilter.id);
        } else {
          const locations = this._shared.locations?.length ? this._shared.locations : this.all_locations;
          this.mainService.setFinanceThemeFromLocations(locations, 'All');
          this.show_pp_subscription = this.mainService.getShowPpSubscriptionFromLocations(locations, 'All');
          this.refreshSubscriptionFlowType('All');
        }

        this.locationSubscription = this._globalFilter.locationFilter
          .subscribe((filter) => {
            if (!filter) return;
            this.locationFilter = filter;
            const locations = this._shared.locations?.length ? this._shared.locations : this.all_locations;
            if (filter.name === 'All' || !filter.id) {
              this.mainService.resetActiveFinanceDoctor();
              this.mainService.setFinanceThemeFromLocations(locations, 'All');
              this.show_pp_subscription = this.mainService.getShowPpSubscriptionFromLocations(locations, 'All');
              this.refreshSubscriptionFlowType('All');
              this.isFinanceStatusLoading = false;
            } else {
              this.mainService.setFinanceThemeFromLocations(locations, filter.id);
              this.show_pp_subscription = this.mainService.getShowPpSubscriptionFromLocations(locations, filter.id);
              this.refreshSubscriptionFlowType(filter.id);
            }
            this.cdr.detectChanges();
          });

      }

      if (!requestedFinanceStatus) {
        this.isFinanceStatusLoading = false;
      }

      this.subscription = this.mainService.financeData$.subscribe((response: any) => {
        this.isFinanceStatusLoading = false;
        const data = response && response.data;

        if (data) {
          this.can_finance = data.can_finance;

          if (data.business_challenge) {
            this.business_challenge = data.business_challenge;
            if (this.business_challenge && this.business_challenge.target_month) {
              this.countDownBusinessDate = new Date(this.business_challenge.target_month).getTime();
            }
            this.startCountdown();
          }

          this.getFinanceStatus();
        } else {
          this.can_finance = 0;
        }
      })
      this.subcription_id = this.doctorSettings ? this.doctorSettings.subscription_id : 1;
      this.mainService.financeData$.subscribe(data => {
        if (data) {
          this.doctorSettings = data.data;
        }
      })
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.setBannerWidth();
    }, 0);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    setTimeout(() => {
      this.setBannerWidth();
    }, 0);
  }

  setBannerWidth() {
    if (!this.cardRef || !this.bannerRef) {
      return;
    }
    let cardWidth = this.cardRef.nativeElement.offsetWidth;
    this.renderer.setStyle(this.bannerRef.nativeElement, 'width', `${cardWidth}px`);
  }


  getFinanceStatus() {
    this._loaderService.hide();
    let res = this.mainService.financeData || JSON.parse(localStorage.getItem('getFinanceValues'));
    if (res && res.data) {
      // tslint:disable-next-line:max-line-length
      this.pp_restricted = res && res.data && res.data.pp_restricted;
      this.show_process_payment = res && res.data && res.data.show_payment_process;
      this.can_finance = res && res.data && res.data.can_finance;
      this.show_ar = res && res.data && res.data.show_ar;
      this.contractData = res && res.data && res.data.contract_count ? res.data.contract_count : 0;
      this.show_pp_subscription = res?.data?.payment_process_subscription_settings.show_pp_subscription;
      this.skip_breakdown = res && res.data && res.data.skip_breakdown;
      localStorage.setItem('skip_breakdown', String(this.skip_breakdown));
      // The finance response is the location-scoped source for the flow type, and
      // for an agent it is the only one — their profile row does not carry it.
      this.refreshSubscriptionFlowType();
    } else {
      this.pp_restricted = 0;
      this.show_process_payment = 0;
      this.can_finance = this.profile[0].can_finance || 0;
      this.show_ar = 0;
    }
    setTimeout(() => {
      this.setBannerWidth();
    }, 100); 
    if (!this.pp_restricted || this.can_finance != 0) {
      this.route.queryParams.subscribe(prams => {
        if (prams.pp_tab) {
          this.pp_restricted === 0;
          if(Number(prams.pp_tab) === 1){
            this.routeMe('app/process-payment/payment', 4, undefined, true);
          } else{
            this.routeMe('app/process-payment/payment', 0);
          }
        }
      })
    }
  }

  redirectSubscription() {
    this._auth.getUsersubscription();
    this.router.navigate(['/app/pricing'], { queryParams: { sp_id: 1 } });
  }

  clearLocalStorage(data, type, isPPSub = false) {
    this._shared.clearLocalStorage();
    this._shared.clearLeadsData();
    setTimeout(() => {
      this.routeMe(data, type, 'pass', isPPSub)
    }, 100);
  }

  clickToLearn(type, event: Event) {
    event.stopPropagation();
    if (type == 0) {
      this.openPP();
    } else if (type == 1) {
      this.openAR();
    } else if (type == 2) {
      this.openFinancing();
    }  else if (type == 3) {
      this.openSubscription();
    } else { return; }
  }

  routeMeWithEvent(event: Event, path: string, id: number): void {
    console.log('herevnkahasdf')
    event.stopPropagation();
    this.routeMe(path, id);
  }

  routeMe(data, type, optional?, isPPSub: boolean = false) {
    console.log('herevnka32342hasdf')

    // if(this.userData[0] && Number(this.userData[0].role_id) == 1 && this.session && this.session[0].name == "All")  {
    //   this._shared.getSelectedBusiness(null, resp => {
    //     this.routeMe(data, type, optional);
    //     return;
    //   })
    // }

    if (this.can_finance == 0) {
      return;
    }
    if (type == 1 && !this.show_ar) {
      return;
    }
    if (type == 0 && this.pp_restricted == 1) {
      return;
    }
    this.is_allowed = this.mainService.subscription_global_setting(14);
    this.is_allowed_ar = this.mainService.subscription_global_setting(15);
    if (type == 0 && !this.is_allowed) {
      this.openSubLock(0);
      return;
    }
    if (type == 1 && !this.is_allowed_ar) {
      this.openSubLock(1);
      return;
    }

    if (type == 2 && optional == undefined) {
      this.clearLocalStorage(data, type, isPPSub);
      return;
    }
    if (type == 0 && optional == undefined) {
      this.clearLocalStorage(data, type, isPPSub);
      return;
    }
    if (type == 1 && optional == undefined) {
      this.clearLocalStorage(data, type, isPPSub);
      return;
    }

    this.profile = getUserProfiles();
    if (data == 'app/process-payment/payment' || data == 'app/accounts-receivable/send-invoice') {
      if (this.profile[0].role_id == 4 && this.profile[0].business_verification_state != 'other_info_updated' && data == 'app/accounts-receivable/send-invoice') {
        var getFinanceValues = localStorage.getItem('getFinanceValues') ? JSON.parse(localStorage.getItem('getFinanceValues')) : {};
        var arv2TotalProposals = 0;
        if (Object.keys(getFinanceValues).length > 0) {
          arv2TotalProposals = (getFinanceValues && getFinanceValues.data && getFinanceValues.data.contract_count && getFinanceValues.data.contract_count.arv2_contracts) ? getFinanceValues.data.contract_count.arv2_contracts : 0;
        }
        if (arv2TotalProposals > 0) {
          this.dialog.open(SimpleDialogComponent, {
            width: '450px',
            panelClass: 'simpleDialog',
            data: {
              type: 44,
              is_ar: 1,
            }
          });
        } else {
          this.router.navigate(['/app/accounts-receivable/send-invoice']);
        }
      } else if (this.profile[0].role_id == 4 && this.profile[0].business_verification_state != 'other_info_updated' && data == 'app/process-payment/payment' && this.mainService.getTraningData.length == 0) {
        this.dialog.open(SimpleDialogComponent, {
          width: '450px',
          panelClass: 'simpleDialog',
          data: {
            type: 902,
            isPPSub: isPPSub,
            getTraningData: this.mainService.getTraningData.length ? this.mainService.getTraningData[0] : []
          }
        });

      } else if (this.profile[0].role_id == 4 && this.profile[0].business_verification_state != 'other_info_updated' && data == 'app/process-payment/payment' && this.mainService.getTraningData.length > 0) {
        this.dialog.open(SimpleDialogComponent, {
          width: '450px',
          panelClass: 'simpleDialog',
          data: {
            type: 903,
            getTraningData: this.mainService.getTraningData.length ? this.mainService.getTraningData[0] : []
          }
        });
      } else if (data == 'app/process-payment/payment') {
        if (this.contractData && this.contractData.pp_contracts == 0 && !this.show_pp_subscription) { this.openPP() }
        else { this.getStartedtoFinance(type, isPPSub) }
      } else {
        if (this.contractData && this.contractData.arv2_contracts == 0) this.openAR();
        else { this.getStartedtoFinance(type) }
      }
      return;
    }

    if (this.subcription_id != 2 && this.doctorSettings && this.doctorSettings.financing_type && (this.doctorSettings.financing_type == 6 || this.doctorSettings.financing_type == 12 || this.doctorSettings.default_financing_type == 6 || this.doctorSettings.default_financing_type == 12) && this.doctorSettings.show_subscription == 1) {
      this.openSubLock(0);
    }
    else {
      if (this.contractData && this.contractData.other_contracts == 0) this.openFinancing();
      else { this.getStartedtoFinance(type) }
    }
  }

  checkUserData(event: Event, data, type, optional?) {
    event.stopImmediatePropagation();
    const isPPSub = type == 4;
    if (this.profile[0] && (Number(this.profile[0].role_id) == 1 && (this.locationFilter && this.locationFilter.name == "All"))) {
      this._shared.getSelectedBusiness('', () => this.routeMe(data, type, optional, isPPSub));
    } else {
      this.routeMe(data, type, optional, isPPSub);
    }
  }

  openPP() {
    let openPopup = this.dialog.openDialogs.find(dialog => dialog.componentInstance.data.type == 100);
    if (openPopup) return;
    this.dialog.closeAll();
    this.dialog.open(ContractDialogComponent, {
      width: '520px',
      panelClass: 'rightFullDialog',
      data: {
        type: 100
      }
    });
  }
  openSubscription() {
    let openPopup = this.dialog.openDialogs.find(dialog => dialog.componentInstance.data.type == 103);
    if (openPopup) return;
    this.dialog.closeAll();
    this.dialog.open(ContractDialogComponent, {
      width: '520px',
      panelClass: 'rightFullDialog',
      data: {
        type: 103
      }
    });
  }

  openAR() {
    let openPopup = this.dialog.openDialogs.find(dialog => dialog.componentInstance.data.type == 101);
    if (openPopup) return;
    this.dialog.open(ContractDialogComponent, {
      width: '520px',
      panelClass: 'rightFullDialog',
      data: {
        type: 101
      }
    });
  }

  openFinancing() {
    let openPopup = this.dialog.openDialogs.find(dialog => dialog.componentInstance.data.type == 99);
    if (openPopup) return;
    this.dialog.open(ContractDialogComponent, {
      width: '520px',
      panelClass: 'rightFullDialog',
      data: {
        type: 99
      }
    });
  }

  openSubLock(val?) {
    let openPopup = this.dialog.openDialogs.find(dialog => dialog.componentInstance.data.type == 101);
    if (openPopup) return;
    this.dialog.open(SimpleDialogComponent, {
      width: '600px',
      disableClose: true,
      panelClass: 'simpleDialog',
      data: {
        type: 101,
        title: '',
        send_data: {
          all_locations: this.all_locations,
          is_ar: val
        }
      }
    });
  }

  /**
   * Re-reads the flow flag for the location currently in scope. Called on every
   * location switch and whenever fresh finance settings land, because the flag
   * is per-location and (for agents) only arrives with those settings — reading
   * it once in ngOnInit left the card on the legacy branch.
   */
  private refreshSubscriptionFlowType(doctorId?: number | string): void {
    const scope = doctorId ?? (this.locationFilter
      ? (this.locationFilter.name === 'All' || !this.locationFilter.id ? 'All' : this.locationFilter.id)
      : undefined);
    this.subscription_flow_type = this.mainService.getSubscriptionFlowType(scope);
  }

  goToSubscriptionV2(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.router.navigate(['/app/subscriptions/payment'], {
      queryParams: { step: 'overview' },
    });
  }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
  }

  private resetFinanceFlowState(): void {
    localStorage.removeItem('financeFlowV3Data');
    localStorage.removeItem('financeFlowV3State');
    localStorage.removeItem('retainUserZipCode');
    localStorage.removeItem('existingUserData');
    localStorage.removeItem('isExistingUser');
    localStorage.removeItem('patientId');
    localStorage.removeItem('customerDetail');
    localStorage.removeItem('emailId');
    this.financingService.clearFinanceData();
  }

  getStartedtoFinance(val, isPPSub = false) {
    if (val == 2) {
      this.router.navigate(['/app/finance']);
    } else if (val == 0 || val == 4) {
      const createSubscription = !!(isPPSub || val == 4);
      this.router.navigate(['/app/process-payment/payment'], {
        queryParams: createSubscription ? { pp_type: 1 } : {},
        state: {
          isPPSub: createSubscription
        }
      });
    } else {
      this.router.navigate(['/app/accounts-receivable/send-invoice']);
    }
  }


  openPopup() {
    this._shared.callYouBackModal('3')
  }

  startCountdown(): void {
    this.intervalId = setInterval(() => {
      const now = new Date().getTime();
      const new_bus_diff = this.countDownBusinessDate - now;
      const days_new_bus = Math.floor(new_bus_diff / (1000 * 60 * 60 * 24));
      this.daysRemaining = `${days_new_bus} days `;
      if (new_bus_diff < 0) {
        clearInterval(this.intervalId);
      }
    }, 1000);
  }


  capitalizeFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  checkChallenge() {
    try {
      return ((this.business_challenge && ((this.business_challenge.need_to_create_contract && (this.business_challenge.need_to_create_contract - this.business_challenge.contract_this_month) > 0) || (this.business_challenge.is_new_business_challenge && !this.business_challenge.is_new_business_challenge_achieved))))
    } catch (error) {
      console.log(error);
    }
  }

  set_values_for_background_processing_data(data) {
    this.number_of_record_processed = data.processed_record_count || 0;
    if (data.is_all_record_processed == 1) {
      this.number_of_record_processed = 0;
    }
  }

  checkBusinessLocations() {
    if (this._shared.locations.length == 0) {
      // this.mainService.customPopups("Please add a location/business to access Denefits features.", 1);

      // this.router.navigate(['/app/dashboard']);
      return;
    } else {
      this.mainService.getTrainingsList()
    }
  }
}
